import React, {Component} from 'react';
import * as firebase from 'firebase';
import ReactLoading from 'react-loading';
import ADPost from '../component/ADPost';
import MetaTags from 'react-meta-tags';
import FacebookProvider, { Comments } from 'react-facebook';
import '../css/blog.css'


export default class Faqs extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      myAnswer: '',
      ansdisplayName: '',
      listOfAns: []
    }
  }
  componentDidMount(blogName) {
    window.scrollTo(0,0)
    firebase.auth().onAuthStateChanged((user) => {
      setTimeout(() => this.setState({ loading: false }), 2400);
        let theId = this.props.match.params.id;
        const faqsRef = firebase.database().ref('faq/').orderByChild('id').equalTo(theId);
        faqsRef.on('value', snap => {
          snap.forEach((child) => {
            this.setState({
              title: child.val().title,
              createDate: child.val().createDate,
              createTime: child.val().createTime,
              displayName: child.val().displayName,
              photoURL: child.val().photoURL,
              info: child.val().info,
              id: child.val().id,
              ansCount: child.val().ansCount
            })
          })
        })

        const ansRef = firebase.database().ref('faq/').child(theId).child('ans');
        ansRef.on('value', snap => {
          snap.forEach((child) => {
             const previousList = this.state.listOfAns;
             previousList.push({
               ansMyAnswer: child.val().myAnswer ? child.val().myAnswer : null,
               ansPhotoURL: child.val().photoURL ? child.val().photoURL : null,
               ansId: child.val().id ? child.val().id : null,
               ansUserId: child.val().userId ? child.val().userId : null
              })
              this.setState({
                listOfAns: previousList.reverse()
             })
          })
        })
    })

  }

  render() {
    const { loading } = this.state;
    if(loading) {
      return <ReactLoading type={"bubbles"} color={"#333"} style={Jeyu.loading} />
    }

    return(
      <div className="container-fluid">
       <div className="row">
        <MetaTags>
            <title>草學藥事 || {this.state.title}</title>
            <meta id="og-title" property="og:title" content={this.state.title} />
        </MetaTags>
        <div className="container">
         <div className="row" style={Jeyu.hasPadding} >
          <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
           <article>
            <img src={this.state.photoURL} alt={this.state.title} style={Jeyu.photoBox} />
            <p>{this.state.displayName}</p>
            <sup>{this.state.createDate} / {this.state.createTime}</sup>
           </article>
           <article>
            <h1>{this.state.title}</h1>
           </article>
           <article>
            <div dangerouslySetInnerHTML={{__html: this.state.info}} className="blogBox"></div>
           </article>     
           <div style={{margin: '15px 0 0 0'}}>
           <FacebookProvider appId="442538242786461">
            <Comments href={'https://herbalcure.com.tw/Faqs/' + this.state.id} />
           </FacebookProvider>
           </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-3 col-md-offset-1 col-lg-3 col-lg-offset-1">
            <ADPost />
          </div>
         </div>
        </div>
       </div>
      </div>
    )
  }
}


const Jeyu = {
  loading: {
    margin: '20% auto',
    width: 77,
    height: '100vh'
  },
  blogBg: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '130px 20px 50px',
    textAlign: 'center'
  },
  hasPadding: {
    padding: '150px 0'
  },
  hasMarginTop: {
    marginBottom: 20
  },
  photoBox: {
    maxHeight: 150,
  },
  Photo: {
    height: 45,
    display: 'block'
  },
  faqAnsBox: {
    margin: '20px 0 30px'
  },
  ansBoxs: {
    padding: 12,
    barderRadius: 5,
    background: '#fff',
    fontSize: 13,
    minHeight: 70
  },
  PreBox: {
    margin: '15px 0'
  }
}



// WEBPACK FOOTER //
// ./src/post/Faqs.js